import './App.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Landing } from './pages/landing';
import { Home } from './pages/home';
import { AuthProvider } from './context/auth-context';
import { ResumesProvider } from './context/resumes-context';
import { BragsheetProvider } from './context/bragsheet-context';
import ProtectedRoute from './utils/routing_utils';
import { ShareableAnalysisPage } from './pages/ShareableAnalysisPage';
import { Header } from './components/header';
import { Footer } from './sections/footer';
import { MyResumesView } from './pages/MyResumesView';
import { BragSheetView } from './pages/BragSheetView';
import { CraftView } from './pages/CraftView';
import { ResumeAnalysis } from './pages/ResumeAnalysis';
import { NotFoundScreen } from './pages/PageNotFound';
import { NAVIGATION_ITEMS } from './utils/constants';
import ResumePrintPage from './components/ResumePrint/ResumePrintPage';

const isNavEnabled = (id) => NAVIGATION_ITEMS.some(item => item.id === id);

function App() {

  return (<AuthProvider>
            
              <BrowserRouter>
                <div className="flex flex-col min-h-screen">
                  <Header />
                  <main className="flex-1 h-full flex flex-col">
                    <Routes>
                      <Route path="/" element={ <ProtectedRoute>
                                                  <ResumesProvider>
                                                     <BragsheetProvider>
                                                        <Outlet />
                                                     </BragsheetProvider>
                                                  </ResumesProvider>
                                                </ProtectedRoute>} >
                          {<Route index element={<Home  />} />}
                          {isNavEnabled('myresumes') && <Route path='myresumes/:resumeId' element={<ResumeAnalysis />} />}
                          {isNavEnabled('myresumes') && <Route path='myresumes/:resumeId/print' element={<ResumePrintPage />} />}
                          {isNavEnabled('myresumes') && <Route path='myresumes' element={<MyResumesView />} />}
                          {isNavEnabled('craft') && <Route path='/craft' element={<CraftView />} />}
                          {isNavEnabled('bragsheet') && <Route path='/bragsheet' element={<BragSheetView />} />}
                      </Route>
                        <Route path='/resume/share/:token' element={<ShareableAnalysisPage />} />

                      <Route path="/landing" element={<Landing/>} />
                      <Route path="*"element={<NotFoundScreen />} />
                    </Routes>
                  </main>
                  <Footer />
                </div>
              </BrowserRouter>
          </AuthProvider>)
}

export default App;
